import { render, staticRenderFns } from "./GuiasForm.vue?vue&type=template&id=1c48caea&scoped=true&"
import script from "./GuiasForm.vue?vue&type=script&lang=js&"
export * from "./GuiasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48caea",
  null
  
)

export default component.exports